import { render, staticRenderFns } from "./LeaveReview.vue?vue&type=template&id=ad924cb0&scoped=true&"
import script from "./LeaveReview.vue?vue&type=script&lang=js&"
export * from "./LeaveReview.vue?vue&type=script&lang=js&"
import style0 from "./LeaveReview.vue?vue&type=style&index=0&id=ad924cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad924cb0",
  null
  
)

export default component.exports